import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import "./LinkOnly.css"


const LinkOnly = ({ blogSectionObj, param }) => {
  var content = blogSectionObj;

  const [pathUrl, setPathUrl] = useState("")
  function scrollToView(id) {
    console.log("scroll-id", id)
    const idSplit = id.split("#")
    console.log("scroll-id-split", idSplit[1])
    const scroll = document.querySelector(`.${idSplit[1]}`);
    console.log("scroll", scroll)
    if (scroll != undefined && scroll != null) {
      scrollTop(scroll.offsetTop)
    }
  }

  const scrollTop = (top) => {
    var height = document.querySelector(`.${content.attributes.class}`).offsetHeight;
    var length = top - height
    window.scrollTo({
      top: parseInt(length),
      behavior: 'smooth'
    });
  };

  return (
    <>
      <div className={`${content.attributes.sectionRendering} ${content.attributes.class}`} dataType="LinkOnly"
        style={content.attributes.sectionPadding ? { padding: `${content.attributes.sectionPadding}` } : {}}>
        <div className={`${content.attributes.linkUrlCss}`}>
          {content.attributes.linkUrl && content.attributes.linkUrl.includes("http") ?
            <a className={`${content.attributes.linkUrl && content.attributes.linkUrl == pathUrl ? "selected-link" : ''} faq-menus `} href={content.attributes.linkUrl ? content.attributes.linkUrl : ""}>
              {content.attributes.linkName}
            </a> : content.attributes.linkUrl.includes("#") ?
              <p className={`${content.attributes.linkUrl && content.attributes.linkUrl == pathUrl ? "selected-link" : ''} faq-menus `} style={{ cursor: "pointer" }} onClick={() => scrollToView(content.attributes.linkUrl)}>
                {content.attributes.linkName}</p> :
              <Link className={`${content.attributes.linkUrl && content.attributes.linkUrl == pathUrl ? "selected-link" : ''} faq-menus `} target={content.attributes.openLinkInNewTabYn === "true" ? "_blank" : ""} to={content.attributes.linkUrl ? content.attributes.linkUrl : ""}>
                {content.attributes.linkName}
              </Link>
          }
        </div>
      </div>
    </>
  )
}

export default LinkOnly
